export const PARTNER_STATUS_ENUM = {
  AWAITING_SIGNED: 'awaiting_signed',
  AWAITING_APPROVED: 'awaiting_approved',
  APPROVED: 'approved',
  REPROVED: 'reproved'
}
